import React from "react";

const loadingImg =
  "https://cdn.auth0.com/blog/auth0-react-sample/assets/loading.svg";

  const Loading = ({ message = "Chargement en cours..." }) => {

  return (
    <>
    <div className="min-h-[100vh] flex flex-col items-center justify-center gap-4">
      <div className="spinner">
        <img src="https://cdn.auth0.com/blog/auth0-react-sample/assets/loading.svg" alt="Chargement..." />
      </div>
      <p className="text-sm text-gray-600 font-bold absolute top-[65%]">{message}</p>
    </div>
    </>
  );
};

export default Loading;